export default __webpack_public_path__ + "3660c1c099208744bd4f14791a831b60.svg";